import { FaRegEdit, FaTrashAlt, FaPlus } from "react-icons/fa";
import Pagination from '@mui/material/Pagination';
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import ButtonIcon from "components/ButtonIcon";
import TableComponent from "components/Table";
import { NewsCategoriesWrapper } from "./styled"
import { newsCategoriesSelector } from 'redux/selector'
import { newsCategoriesActions } from 'redux/slice/newsCategoriesSlice'
import AdminLoading from "components/AdminLoading";
import Modal from "./Modal";
import Loading from "components/Loading";

const NewsCategories = () => {
    document.title = 'Quản lý loại bài viết'
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const qPage = query.get("page")
    const navigate = useNavigate()

    const [showModal, setShowModal] = useState(false)
    const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1)
    const newsCategoriesState = useSelector(newsCategoriesSelector)
    const dispatch = useDispatch()
    const [method, setMethod] = useState('add')
    const [selectedId, setSelectedId] = useState(null)
    const [totalItemInPage, setTotalItemInPage] = useState(0)

    useEffect(() => {
        dispatch(newsCategoriesActions.getNewsCategories({ currentPage }))
    }, [currentPage, dispatch])


    const handleChangePaginate = (event, pageNumber) => {
        setCurrentPage(pageNumber)
        navigate(`/admin/news-category?page=${pageNumber}`)
    }

    const handleHiddenForm = () => {
        setSelectedId(null)
        setShowModal(!showModal)
    }

    const handleShowAddModal = () => {
        setMethod('add')
        setShowModal(!showModal)
    }

    const handleShowUpdateModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('update')
        setShowModal(!showModal)
    }

    const handleShowRemoveModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('remove')
        setShowModal(!showModal)
    }

    const columns = [
        {
            title: 'Mã loại bài viết',
            dataIndex: 'id',
            key: 'id',
            align: "center"
        },
        {
            title: 'Tên loại bài viết',
            dataIndex: 'name',
            key: 'name',
            align: "center"
        },
        {
            title: 'Ngày tạo',
            dataIndex: 'created_at',
            key: 'created_at',
            align: "center"
        },
        {
            title: 'Thao tác',
            key: 'action',
            align: 'center',
            render: (_, { id }) => (
                <>
                    <ButtonIcon
                        onClick={() => handleShowUpdateModal(id)}
                        icon={<FaRegEdit />}
                        description='Sửa'
                        classButton="action-danger-2 btn-action"
                    />
                    <ButtonIcon
                        onClick={() => handleShowRemoveModal(id)}
                        icon={<FaTrashAlt />}
                        description='Xóa'
                        classButton="action-danger btn-action"

                    />
                </>
            ),
        },
    ];

    useMemo(() => {
        if (currentPage > 1) {
            setTotalItemInPage((currentPage - 1) * 5 + newsCategoriesState.newsCategoriesList.length)
        }
        else {
            setTotalItemInPage(newsCategoriesState.newsCategoriesList.length)
        }
    }, [currentPage, newsCategoriesState.newsCategoriesList.length])

    return (
        <NewsCategoriesWrapper className="admin_news_categories">
            <div className="admin_news_categories_control py-0 px-15">
                <div></div>
                <div className="admin_news_categories_control_sort-add">
                    <ButtonIcon
                        onClick={handleShowAddModal}
                        icon={<FaPlus />}
                        description="Thêm mới"
                        classButton="btn_add action-danger-1"
                    />
                </div>
            </div>
            <div className="admin_news_categories_table">

                {
                    newsCategoriesState.isFetching && <Loading />
                }
                <TableComponent
                    columns={columns}
                    data={newsCategoriesState?.newsCategoriesList}
                />
            </div>
            {
                newsCategoriesState?.newsCategoriesList?.length > 0 &&
                <div className="admin_news_categories_pagination mt-15 px-15">
                    <span className="admin_news_categories_pagination_total_item medium">
                        {totalItemInPage} / {newsCategoriesState.totalItem}
                    </span>
                    {
                        newsCategoriesState.totalPage > 1 &&
                        <Pagination count={newsCategoriesState.totalPage} color="primary"
                            onChange={(event, pageNumber) => handleChangePaginate(event, pageNumber)}
                            page={currentPage}
                        />
                    }
                </div>
            }
            <Modal
                selectedId={selectedId}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                showModal={showModal}
                hidden={handleHiddenForm}
                method={method}
            />
        </NewsCategoriesWrapper>
    );
}

export default NewsCategories;